import { useState } from "react";
import { Box } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Text from "../text/Text";
import Button from "../button/Button";
import {
  accountSuspendedHeader,
  accountSuspendedSubMsg,
  contactSupport,
  signOut,
} from "../messages";
import { expireSession, handleContactSupport } from "../constants";

const AccountSuspended = () => {
  const [disabled, setDisabled] = useState(false);

  const handleLogout = async () => {
    setDisabled(true);
    try {
      await expireSession();
    } catch (error) {
    } finally {
      setDisabled(false);
    }
  };

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={3}
        mt={7}
      >
        <ErrorOutlineIcon
          sx={{ color: "#FF0000", height: "54px", width: "54px" }}
        />
        <Text className="default-text" size={24} font="bold">
          {accountSuspendedHeader}
        </Text>
        <Text
          className="grey-text"
          size={14}
          font="regular"
          sx={{ textAlign: "center" }}
        >
          {accountSuspendedSubMsg}
        </Text>
      </Box>
      <Box gap="15px" left={0} display="flex" flexDirection="column">
        <Button
          variant="outlined"
          label={signOut}
          onClick={handleLogout}
          disabled={disabled}
        />
        <Button
          variant="contained"
          label={contactSupport}
          onClick={handleContactSupport}
          disabled={disabled}
        />
      </Box>
    </>
  );
};

export default AccountSuspended;
